// @flow

export default {
  wizard: {
    next: 'Nästa',
    back: 'Tillbaka',
    skip: 'Hoppa',
    sort: 'Sortera',
    sorting: {
      'utility:desc': 'Bästa resultat',
      'price:asc': 'Prisuppstigning',
      'price:desc': 'Prisfall',
      'created_at:desc': 'Nyaste',
      'customer_rating:desc': 'Kundbetyg'
    },
    clickToAddFiles: 'Klicka för att lägga till dina filer eller släpp dem här.',
    searchFor: 'Söka efter ...',
    noSearchResults: 'Tyvärr har vi inte hittat några lämpliga alternativ. Vänligen sök igen.',
    loadMoreAnswerOptions: 'Inget lämpligt alternativ här? Visa alla alternativ.',
    noRecommendationDescription: 'Å nej, tyvärr kunde vi inte hitta några produkter som passar dina behov.',
    noRecommendationDescription2: 'Starta om produktrådgivaren.',
    noRecommendationRestartButtonTitle: 'Omstart',
    noRecommendationCloseButtonTitle: 'Nära',
    removeFile: 'Ta bort filen'
  },
  chatbot: {
    selectAll: 'Välj alla',
    none: 'Ingen',
    confirmButton: 'Bekräfta',
    customerServiceInputPlaceholder: 'Skriv ett meddelande ...',
    you: 'Du',
    restart: 'Börja igen',
    close: 'Nära',
    send: 'Skicka',
    supportChat: 'Supportchatt',
    honeypot: 'Lämna detta fält tomt',
    scrollToTheLatestMessage: 'Skrolla till det senaste meddelandet',
    removeFile: 'Ta bort filen'
  },
  product: {
    loadMore: 'Ladda fler produkter',
    badgeTitle: 'Vår rekommendation',
    ctaButtonTitle: 'Upptäcka produkt',
    matchingPanelTitle: 'Skräddarsydd efter dina behov',
    bestFit: 'Bästa passform',
    bestPrice: 'Bästa pris',
    bestFitForPrice: 'Bästa valuta för pengarna',
    addToCartError: 'Lägg till CART var inte framgångsrik. Var god försök igen',
    addRoutineToCart: 'Lägg till i kundvagn',
    explanationHeader: 'Mer produktinformation:',
    emptyRoutineItem: 'Tyvärr finns det ingen produkt i den kategorin som matchar dina preferenser.'
  },
  tabBar: {
    chat: 'Chat',
    productAdvisor: 'Produktrådgivare'
  },
  recommender: {
    answerOptionLeadsToNoRecommendation: 'Tyvärr skulle detta alternativ inte leda till någon önskad produkt. Du kan ändra dina preferenser i tidigare steg för att aktivera alternativet.'
  }
}
